export const environment = {
  homolog: true,
  api: "https://api.dev.paulistacultural.com.br",
};
